import React, { useCallback, useContext, useState } from 'react'
import { Col, Row, Card, Form, InputGroup, Button } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faSearch, faUndo } from '@fortawesome/free-solid-svg-icons'
import Datetime from 'react-datetime'
import moment from 'moment-timezone'
import { Context } from '../User'

const DateField = ({ label, value, onChange }) => (
  <Col xs={12} lg={6} className="mb-3">
    <Form.Label>{label}</Form.Label>
    <Datetime
      timeFormat={false}
      value={value || ''}
      onChange={onChange}
      closeOnSelect
      renderInput={(props, openCalendar) => (
        <InputGroup>
          <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
          <Form.Control
            type="text"
            value={value ? moment(value).format('DD/MM/YYYY') : ''}
            placeholder="dd/mm/yyyy"
            onFocus={openCalendar}
            onChange={() => {}}
          />
        </InputGroup>
      )}
    />
  </Col>
)

const _FilterForm = () => {

  const { state, dispatch } = useContext(Context);
  const [form, setForm] = useState(state)

  const setValue = useCallback((name, value) => {
    setForm(current => ({ ...current, [name]: value }))
  }, [])

  const _submitForm = useCallback((event) => {
    event && event.preventDefault()
    dispatch({
      type: 'SUBMIT_FILTER',
      payload: form
    })
  }, [dispatch, form])

  const _resetForm = useCallback(() => {
    const emptyForm = {
      phone: '',
      keyword: '',
      status: '',
      registeredFrom: null,
      registeredTo: null,
      lastBuyFrom: null,
      lastBuyTo: null
    }
    setForm(emptyForm)
    dispatch({ type: 'SUBMIT_FILTER', payload: emptyForm })
  }, [dispatch])

  return (
    <Form onSubmit={_submitForm}>
      <Card border="light" className="shadow-sm mb-3">
        <Card.Header>
          <Row className="align-items-center">
            <Col className='align-self-center'>
              <h5 className="mb-0">KHÁCH HÀNG</h5>
            </Col>
            <Col xs="auto" className='text-right'>
              <Button className="me-2" variant="outline-secondary" type="button" onClick={_resetForm}>
                <FontAwesomeIcon icon={faUndo} className="me-2" />Đặt lại
              </Button>
              <Button variant="info" type="submit">
                <FontAwesomeIcon icon={faSearch} className="me-2" />Tìm kiếm
              </Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col xs={12} md={4} className="mb-3">
              <Form.Label>Số điện thoại</Form.Label>
              <Form.Control value={form.phone} onChange={event => setValue('phone', event.target.value)} type="text" placeholder="Nhập số điện thoại" />
            </Col>
            <Col xs={12} md={4} className="mb-3">
              <Form.Label>Tên / CCCD</Form.Label>
              <Form.Control value={form.keyword} onChange={event => setValue('keyword', event.target.value)} type="text" placeholder="Nhập tên hoặc CCCD" />
            </Col>
            <Col xs={12} md={4} className="mb-3">
              <Form.Label>Trạng thái</Form.Label>
              <Form.Select value={form.status} onChange={event => setValue('status', event.target.value)}>
                <option value="">Tất cả</option>
                <option value="1">Đang hoạt động</option>
                <option value="0">Ngừng hoạt động</option>
              </Form.Select>
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={6}>
              <div className="text-muted small fw-bold mb-2">NGÀY ĐĂNG KÝ</div>
              <Row>
                <DateField label="Từ ngày" value={form.registeredFrom} onChange={value => setValue('registeredFrom', value)} />
                <DateField label="Đến ngày" value={form.registeredTo} onChange={value => setValue('registeredTo', value)} />
              </Row>
            </Col>
            <Col xs={12} lg={6}>
              <div className="text-muted small fw-bold mb-2">LẦN CUỐI MUA VÉ</div>
              <Row>
                <DateField label="Từ ngày" value={form.lastBuyFrom} onChange={value => setValue('lastBuyFrom', value)} />
                <DateField label="Đến ngày" value={form.lastBuyTo} onChange={value => setValue('lastBuyTo', value)} />
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Form>
  );
};

export default React.memo(_FilterForm)
